import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=948c511c&scoped=true&"
import script from "./Usage.vue?vue&type=script&lang=js&"
export * from "./Usage.vue?vue&type=script&lang=js&"
import style0 from "./Usage.vue?vue&type=style&index=0&id=948c511c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948c511c",
  null
  
)

export default component.exports